import { render } from "./NewGuardianChat.vue?vue&type=template&id=edb6aac4&scoped=true"
import script from "./NewGuardianChat.vue?vue&type=script&lang=js"
export * from "./NewGuardianChat.vue?vue&type=script&lang=js"

import "./NewGuardianChat.vue?vue&type=style&index=0&id=edb6aac4&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb6aac4"]])

export default __exports__